import {
  symOutlinedEdit,
  symOutlinedDelete,
  symOutlinedUpload,
  symOutlinedClose,
  symOutlinedCancel,
  symOutlinedFolderCopy,
  symOutlinedHelp,
  symOutlinedArrowForward,
  symOutlinedNotifications,
  symOutlinedNotificationsUnread,
  symOutlinedKey,
  symOutlinedContentCopy,
  symOutlinedPersonAdd,
  symOutlinedWarning,
  symOutlinedPersonOff,
  symOutlinedBlock,
  symOutlinedForwardToInbox,
  symOutlinedInbox,
  symOutlinedFilterAlt,
  symOutlinedFolderOpen,
  symOutlinedSearch,
  symOutlinedPerson,
  symOutlinedInfo,
  symOutlinedArrowBack,
  symOutlinedAccountCircle,
  symOutlinedCalendarToday,
  symOutlinedDeployedCode,
  symOutlinedCheckCircle,
  symOutlinedSchedule,
  symOutlinedInventory2,
  symOutlinedTimelapse,
  symOutlinedClockLoader40,
  symOutlinedPageInfo,
  symOutlinedBeenhere,
  symOutlinedKeyboardArrowUp,
  symOutlinedKeyboardArrowDown,
  symOutlinedAcUnit,
  symOutlinedLock,
  symOutlinedSyncAlt,
  symOutlinedTask,
  symOutlinedChat,
  symOutlinedBarChart4Bars,
  symOutlinedVisibility,
  symOutlinedMoreVert,
  symOutlinedDownload,
  symOutlinedCheck,
  symOutlinedEventBusy,
  symOutlinedFormatBold,
  symOutlinedFormatItalic,
  symOutlinedAddLink,
  symOutlinedFormatListBulleted,
  symOutlinedFormatListNumbered,
  symOutlinedChecklist,
  symOutlinedFormatAlignCenter,
  symOutlinedFormatAlignRight,
  symOutlinedFormatAlignLeft,
  symOutlinedUndo,
  symOutlinedRefresh,
  symOutlinedError,
  symOutlinedAdd,
  symOutlinedContactSupport,
  symOutlinedThumbUp,
} from '@quasar/extras/material-symbols-outlined';

export const editOutlined = symOutlinedEdit;
export const deleteOutlined = symOutlinedDelete;
export const uploadOutlined = symOutlinedUpload;
export const closeOutlined = symOutlinedClose;
export const cancelOutlined = symOutlinedCancel;
export const folderCopyOutlined = symOutlinedFolderCopy;
export const helpOutlined = symOutlinedHelp;
export const forwardArrowOutlined = symOutlinedArrowForward;
export const notificationsOutlined = symOutlinedNotifications;
export const notificationsUnreadOutlined = symOutlinedNotificationsUnread;
export const keyOutlined = symOutlinedKey;
export const contentCopyOutlined = symOutlinedContentCopy;
export const personAddOutlined = symOutlinedPersonAdd;
export const warningOutlined = symOutlinedWarning;
export const personOffOutlined = symOutlinedPersonOff;
export const blockOutlined = symOutlinedBlock;
export const forwardToInboxOutlined = symOutlinedForwardToInbox;
export const inboxOutlined = symOutlinedInbox;
export const filterAltOutlined = symOutlinedFilterAlt;
export const folderOpenOutlined = symOutlinedFolderOpen;
export const searchOutlined = symOutlinedSearch;
export const personOutlined = symOutlinedPerson;
export const infoOutlined = symOutlinedInfo;
export const arrowBackOutlined = symOutlinedArrowBack;
export const accountCircleOutlined = symOutlinedAccountCircle;
export const calendarTodayOutlined = symOutlinedCalendarToday;
export const deployedCodeOutlined = symOutlinedDeployedCode;
export const checkCircleOutlined = symOutlinedCheckCircle;
export const scheduleOutlined = symOutlinedSchedule;
export const inventory2Outlined = symOutlinedInventory2;
export const clockLoader60Outlined = symOutlinedTimelapse;
export const clockLoader40Outlined = symOutlinedClockLoader40;
export const pageInfoOutlined = symOutlinedPageInfo;
export const beenhereOutlined = symOutlinedBeenhere;
export const keyboardArrowUpOutlined = symOutlinedKeyboardArrowUp;
export const keyboardArrowDownOutlined = symOutlinedKeyboardArrowDown;
export const acUnitOutlined = symOutlinedAcUnit;
export const lockOutlined = symOutlinedLock;
export const syncAltOutlined = symOutlinedSyncAlt;
export const taskOutlined = symOutlinedTask;
export const chatOutlined = symOutlinedChat;
export const barChartOutlined = symOutlinedBarChart4Bars;
export const visibilityOutlined = symOutlinedVisibility;
export const moreVertOutlined = symOutlinedMoreVert;
export const downloadOutlined = symOutlinedDownload;
export const checkOutlined = symOutlinedCheck;
export const eventBusyOutlined = symOutlinedEventBusy;
export const formatBoldOutlined = symOutlinedFormatBold;
export const formatItalicOutlined = symOutlinedFormatItalic;
export const addLinkOutlined = symOutlinedAddLink;
export const formatListBulletedOutlined = symOutlinedFormatListBulleted;
export const formatListNumberedOutlined = symOutlinedFormatListNumbered;
export const checklistOutlined = symOutlinedChecklist;
export const formatAlignCenterOutlined = symOutlinedFormatAlignCenter;
export const formatAlignRightOutlined = symOutlinedFormatAlignRight;
export const formatAlignLeftOutlined = symOutlinedFormatAlignLeft;
export const undoOutlined = symOutlinedUndo;
export const refreshOutlined = symOutlinedRefresh;
export const errorOutlined = symOutlinedError;
export const addOutlined = symOutlinedAdd;
export const contactSupportOutlined = symOutlinedContactSupport;
export const thumbUpOutlined = symOutlinedThumbUp;
